// import packages
import React, { useEffect, useRef, useState } from "react";

// Import assets
import '../assets/styles/components/mouse-tracker.scss'

// Import utils

const MouseTracker = ({ children, offsetX, offsetY, visible }) => {
    const element = useRef({});

    useEffect(() => {
        function handler(ev) {
            if (element.current) {
                const e = ev.touches ? ev.touches[0] : ev;
                const x = e.clientX + offsetX, y = e.clientY + offsetY;
                element.current.style.transform = `translate(${x}px, ${y}px)`;
                element.current.style.visibility = 'visible';
            }
        }
        visible && document.addEventListener('mousemove', handler);
        visible && document.addEventListener('touchmove', handler);
        return () => {
            visible && document.removeEventListener('mousemove', handler);
            visible && document.removeEventListener('touchmove', handler);
        }
    }, [visible, offsetX, offsetY]);

    return visible && <div className='mouse-tracker' ref={element}>
        {children}
    </div>;
}

export default MouseTracker;
